import axios from 'axios';

import { useServicerStore } from '../store';

const BankAccountService = {
  async createBankAccount(data) {
    const response = await axios.post('/bank_account', {
      ...data,
      servicer_id: useServicerStore.getState()?.servicerId,
    });

    return response.data;
  },

  async archiveBankAccount(bankAccountId) {
    const response = await axios.patch(`/bank_account/${bankAccountId}`, {
      status: 'archived',
    });

    return response.data;
  },

  async deleteBankAccount(bankAccountId) {
    const response = await axios.delete(`/bank_account/${bankAccountId}`);

    return response.data;
  },

  async updateBankAccount(formValues) {
    const response = await axios.patch(
      `/bank_account/${formValues.id}`,
      formValues
    );

    return response;
  },
};

export default BankAccountService;
